import { getEnvValue } from './utils';

export default Object.freeze({
  reCaptchaV2: {
    siteKey: getEnvValue('NEXT_PUBLIC_RE_CAPTCHA_APP_SITE_KEY'),
  },
  rwaNoteBackend: {
    apiUrl: getEnvValue('NEXT_PUBLIC_RWA_BACKEND_API_URL'),
  },
  rwaNoteContract: {
    address: getEnvValue('NEXT_PUBLIC_RWA_NOTE_CONTRACT_ADDRESS'),
  },
});
